import type { SearchResults } from 'algoliasearch-helper';

import type { Item } from '../interfaces';

export const facetsToRadioItem = (
  values: SearchResults.FacetValue[] = [],
): Item[] =>
  values.map(
    (facetValue) =>
      ({
        value: facetValue.name,
        label: facetValue.name,
        active: facetValue.isRefined,
        count: facetValue.count,
      }) as Item,
  ) || [];
